/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import AnnuityValueSection from './components/annuityValueSection';
import CommonQuestionsAnswersFaq from './components/commonQuestionAnswersFaq';
import Form5498Faq from './components/form5498Faq';
import IncomePaymentSection from './components/incomePaymentSection';
import OnlineInfoSection from './components/onlineInfoSection';
import RequestTechnicalFaq from './components/requestTechnicalFaq';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Frequently Asked Questions',
          linkUrl: '/faq/',
          linkAriaLabel: 'Northwestern Mutual Frequently Asked Questions',
        },
        {
          pageName: 'Annuity - Frequently Asked Questions',
          linkUrl: '/faq/annuity-faq/',
          linkAriaLabel: 'Northwestern Mutual Annuity - Frequently Asked Questions',
        },
      ]}
      mainAttributes={{
        itemScope: true,
        itemType: 'https://schema.org/FAQPage',
      }}>

      {/* ONLINE INFO SECTION */}
      <OnlineInfoSection />

      {/* COMMON QUESTIONS ANSWERS FAQ */}
      <CommonQuestionsAnswersFaq />

      {/* INCOME PAYMENT SECTION */}
      <IncomePaymentSection />

      {/* ANNUITY VALUE */}
      <AnnuityValueSection />

      {/* FORM 5498 FAQ */}
      <Form5498Faq />

      {/* REQUEST TECHNICAL FAQ */}
      <RequestTechnicalFaq />

    </Page>
  );
};
